<script>
  import TaskLog from './TaskLog.svelte';
  import TaskDetail from './TaskDetail.svelte';
  import Comments from './Comments.svelte';
  import Reminder from './Reminder.svelte';
  import SendEmail from './SendEmail.svelte';

  import ReasonsModal from './ReasonsModal.svelte';
  let showType = 1;
  let taskMailModal;

  import { Modal } from 'bootstrap';
  import { getContext, onMount } from 'svelte';
  const keyboardListnerStatus = getContext('keyboardListnerStatus');
  let editTaskModal;
  let taskDetailSection;
  export let id;
  let comeFrom;
  export const show = (taskId, oldComeFrom) => {
    comeFrom = oldComeFrom;
    id = taskId;
    editTaskModal = new Modal(document.getElementById('editTaskModal'), {
      keyboard: false,
      backdrop: 'static',
    });
    editTaskModal.show();
    changeShowType(1);
  };

  onMount(() => {
    document
      .getElementById('editTaskModal')
      .addEventListener('hidePrevented.bs.modal', function () {
        setTimeout(() => {
          hide('manual');
        }, 100);
        return false;
      });
    document.getElementById('editTaskModal').addEventListener('hidden.bs.modal', function () {
      keyboardListnerStatus(false);
    });
  });

  const confirmDraftStatus = getContext('confirmDraftStatus');
  export const hide = (flag) => {
    if (editTaskModal != undefined) {
      confirmDraftStatus({
        show: flag == 'manual',
        okFunc: () => {
          editTaskModal.hide();
        },
      });
    }
  };

  const changeShowType = (flag) => {
    confirmDraftStatus({
      okFunc: () => {
        showType = flag;
        setTimeout(() => {
          taskDetailSection.show(id, comeFrom);
        }, 100);
      },
    });
  };

  let showReminder = false;
  let isSubTask = false;
  let isSchedule = false;
</script>

<div>
  <div
    class="modal fade slide-modal font-size-13"
    id="editTaskModal"
  >
    <div class="modal-dialog add-task-modal h-100 m-0 float-end">
      <div class="modal-content">
        <div class="d-flex flex-column h-100">
          <div class="modal-header rounded-0">
            <h5 class="modal-title font-size-14">
              Edit {isSchedule ? 'Scheduled ' : ''}
              {isSubTask ? 'Sub' : ''} Task
            </h5>
            <button
              type="button"
              class="close btn-close"
              on:click={() => hide('manual')}
              aria-label="Close"
            >
              <span aria-hidden="true" />
            </button>
          </div>

          <div class="tabs-header-block">
            <div class="header-tab-btn">
              <div class="d-flex flex-row justify-content-between">
                <div>
                  <button
                    on:click={() => {
                      changeShowType(1);
                    }}
                    class="mb-0 shadow-none bg-transparent border-0 rounded-0 mx-3 {showType == 1
                      ? 'active'
                      : null}"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 100 100"
                      ><path
                        d="M100 12.5V56.25H0V12.5H100ZM93.75 18.75H6.25V50H93.75V18.75ZM87.5 31.25H37.5V25H87.5V31.25ZM68.75 43.75H37.5V37.5H68.75V43.75ZM31.25 43.75H12.5V25H31.25V43.75ZM25 31.25H18.75V37.5H25V31.25ZM12.5 62.5H87.5V68.75H12.5V62.5ZM25 75H75V81.25H25V75Z"
                        fill=""
                      /></svg
                    >
                    Task Details
                  </button>
                  <button
                    on:click={() => {
                      changeShowType(2);
                    }}
                    class="mb-0 shadow-none bg-transparent border-0 rounded-0 mx-3 {showType == 2
                      ? 'active'
                      : null}"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 100 100"
                      fill=""
                      ><path
                        d="M44.5 28.0008H50V50.0006H44.5V28.0008ZM28 39.0007H6V17.001H11.5V28.7743C13.4193 25.2509 15.7539 22.0855 18.5039 19.2783C21.2539 16.471 24.2904 14.0934 27.6133 12.1456C30.9362 10.1977 34.5026 8.67945 38.3125 7.59093C42.1224 6.5024 46.0182 5.97246 50 6.0011C54.0391 6.0011 57.9349 6.51672 61.6875 7.54796C65.4401 8.57919 68.9492 10.0544 72.2148 11.9737C75.4805 13.8929 78.4453 16.1846 81.1094 18.8486C83.7734 21.5126 86.0651 24.4918 87.9844 27.786C89.9036 31.0802 91.3789 34.5893 92.4102 38.3132C93.4414 42.0371 93.9714 45.9329 94 50.0006H88.5C88.5 46.4772 88.0417 43.0827 87.125 39.8171C86.2083 36.5515 84.9193 33.4864 83.2578 30.6219C81.5964 27.7573 79.5768 25.1506 77.1992 22.8017C74.8216 20.4527 72.2292 18.4476 69.4219 16.7861C66.6146 15.1247 63.5495 13.8213 60.2266 12.876C56.9036 11.9307 53.4948 11.4724 50 11.501C46.3047 11.501 42.7096 12.0167 39.2148 13.0479C35.7201 14.0791 32.4688 15.5544 29.4609 17.4736C26.4531 19.3929 23.7174 21.6988 21.2539 24.3915C18.7904 27.0842 16.7852 30.1206 15.2383 33.5008H28V39.0007ZM50 55.5005H94V61.0004H50V55.5005ZM50 72.0003H94V77.5002H50V72.0003ZM50 88.5001H94V94H50V88.5001ZM12.918 60.27C13.9492 63.9652 15.4531 67.3884 17.4297 70.5394C19.4062 73.6904 21.7839 76.469 24.5625 78.8752C27.3411 81.2814 30.4062 83.2866 33.7578 84.8907C37.1094 86.4949 40.6901 87.5548 44.5 88.0704V93.6563C40.0885 93.0547 35.9062 91.8659 31.9531 90.0899C28 88.3139 24.4193 86.0509 21.2109 83.3009C18.0026 80.551 15.2383 77.3427 12.918 73.676C10.5977 70.0094 8.83594 66.0277 7.63281 61.7309L12.918 60.27Z"
                        fill=""
                      /></svg
                    >
                    Task History Log</button
                  >
                  <button
                    on:click={() => {
                      changeShowType(3);
                    }}
                    class="mb-0 shadow-none bg-transparent border-0 rounded-0 mx-3 {showType == 3
                      ? 'active'
                      : null}"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 100 100"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      ><path
                        d="M91 14V70.8285H38.2686L19.25 90V70.8285H9V14H91ZM85.875 19.1662H14.125V65.6622H24.375V77.488L36.1064 65.6622H85.875V19.1662ZM60.25 44.9973H55.125V34.6649H65.375V44.9973C65.375 45.7238 65.2415 46.3965 64.9746 47.0154C64.7077 47.6343 64.3473 48.1724 63.8936 48.6298C63.4398 49.0873 62.8926 49.464 62.252 49.76C61.6113 50.0559 60.944 50.1905 60.25 50.1636V44.9973ZM39.75 44.9973H34.625V34.6649H44.875V44.9973C44.875 45.7238 44.7415 46.3965 44.4746 47.0154C44.2077 47.6343 43.8473 48.1724 43.3936 48.6298C42.9398 49.0873 42.3926 49.464 41.752 49.76C41.1113 50.0559 40.444 50.1905 39.75 50.1636V44.9973Z"
                        fill=""
                      /></svg
                    >
                    Comments</button
                  >
                  {#if showReminder}
                    <button
                      on:click={() => {
                        changeShowType(4);
                      }}
                      class="mb-0 bg-transparent border-0 rounded-0 mx-3 {showType == 4
                        ? 'active'
                        : null}"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 100 100"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        ><path
                          d="M50 100C45.9635 100 42.0898 99.4792 38.3789 98.4375C34.668 97.3958 31.1849 95.931 27.9297 94.043C24.6745 92.1549 21.7285 89.8763 19.0918 87.207C16.4551 84.5378 14.1764 81.5918 12.2559 78.3691C10.3353 75.1465 8.85417 71.6634 7.8125 67.9199C6.77083 64.1764 6.25 60.2865 6.25 56.25C6.25 52.2135 6.77083 48.3398 7.8125 44.6289C8.85417 40.918 10.319 37.4349 12.207 34.1797C14.0951 30.9245 16.3737 27.9785 19.043 25.3418C21.7122 22.7051 24.6582 20.4264 27.8809 18.5059C31.1035 16.5853 34.5866 15.1042 38.3301 14.0625C42.0736 13.0208 45.9635 12.5 50 12.5C54.0365 12.5 57.9102 13.0208 61.6211 14.0625C65.332 15.1042 68.8151 16.569 72.0703 18.457C75.3255 20.3451 78.2715 22.6237 80.9082 25.293C83.5449 27.9622 85.8236 30.9082 87.7441 34.1309C89.6647 37.3535 91.1458 40.8366 92.1875 44.5801C93.2292 48.3236 93.75 52.2135 93.75 56.25C93.75 60.2865 93.2292 64.1602 92.1875 67.8711C91.1458 71.582 89.681 75.0651 87.793 78.3203C85.9049 81.5755 83.6263 84.5215 80.957 87.1582C78.2878 89.7949 75.3418 92.0736 72.1191 93.9941C68.8965 95.9147 65.4134 97.3958 61.6699 98.4375C57.9264 99.4792 54.0365 100 50 100ZM50 18.75C44.8242 18.75 39.974 19.7266 35.4492 21.6797C30.9245 23.6328 26.9531 26.3184 23.5352 29.7363C20.1172 33.1543 17.4316 37.1257 15.4785 41.6504C13.5254 46.1751 12.5326 51.0417 12.5 56.25C12.5 61.4258 13.4766 66.276 15.4297 70.8008C17.3828 75.3255 20.0684 79.2969 23.4863 82.7148C26.9043 86.1328 30.8757 88.8184 35.4004 90.7715C39.9251 92.7246 44.7917 93.7174 50 93.75C55.1758 93.75 60.026 92.7734 64.5508 90.8203C69.0755 88.8672 73.0469 86.1816 76.4648 82.7637C79.8828 79.3457 82.5684 75.3743 84.5215 70.8496C86.4746 66.3249 87.4674 61.4583 87.5 56.25C87.5 51.0742 86.5234 46.224 84.5703 41.6992C82.6172 37.1745 79.9316 33.2031 76.5137 29.7852C73.0957 26.3672 69.1243 23.6816 64.5996 21.7285C60.0749 19.7754 55.2083 18.7826 50 18.75ZM50 56.25V31.25H43.75V62.5H68.75V56.25H50Z"
                          fill=""
                        /></svg
                      >
                      Reminder</button
                    >
                  {/if}
                </div>

                <div>
                  {#if showReminder}
                    <button
                      type="button"
                      on:click={() => {
                        taskMailModal.showModal(id);
                      }}
                      class="border-0 task-right-action p-0 bg-transparent"
                    >
                      <img
                        class="icon-16"
                        alt=""
                        src="/images/mail.svg"
                      />
                    </button>
                  {/if}
                </div>
              </div>
            </div>
          </div>
          {#if showType == 1}
            <TaskDetail
              bind:this={taskDetailSection}
              setTaskData={(item) => {
                id = item.id;
                isSubTask = item.parentId > 0;
                isSchedule = item.isSchedule == 1;
                showReminder = item.recurring == 0;
                setTimeout(() => {
                  if (comeFrom != undefined && comeFrom == 'comment') {
                    comeFrom = undefined;
                    changeShowType(3);
                  } else if (comeFrom != undefined && comeFrom == 'reminder' && showReminder) {
                    changeShowType(4);
                    comeFrom = undefined;
                  }
                }, 250);
              }}
            />
          {/if}
          {#if showType == 2}
            <TaskLog bind:this={taskDetailSection} />
          {/if}

          {#if showType == 3}
            <Comments bind:this={taskDetailSection} />
          {/if}

          {#if showType == 4}
            <Reminder bind:this={taskDetailSection} />
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Button trigger modal -->

<!-- Add Teplate Modal  -->
<div
  class="modal fade custom-modal"
  id="taskModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="taskModalLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title font-size-14"
          id="taskModalLabel"
        >
          Modal title
        </h5>
        <button
          type="button"
          class="close btn-close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true" />
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <input
            type="text"
            class="form-control"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal">Cancel</button
        >
        <button
          type="button"
          class="btn btn-primary">Save changes</button
        >
      </div>
    </div>
  </div>
</div>
<!-- Add Teplate Modal end  -->
<SendEmail bind:this={taskMailModal} />
<ReasonsModal />

<style lang="scss">
  .custom-modal {
    .modal-header {
      border-color: $input-border-color;
      padding: 0.6rem 1.6rem;
    }
    .modal-body {
      padding: 0.6rem 1.6rem;
    }
  }

  .tabs-header-block {
    border-bottom: 1px solid $input-border-color;

    .header-tab-btn {
      button {
        border: 0px;
        padding: 19px 4px 10px;
        transition:
          visibility 0.25s,
          opacity 0.25s,
          transform 0.25s;

        svg {
          fill: $lead-color;
        }

        &.active {
          box-shadow: inset 0 -2px $blue-color;
          color: $blue-color;
          font-weight: 400;
          svg {
            fill: $blue-color;
          }
        }
        &:hover {
          box-shadow: inset 0 -2px $blue-color;
          color: $blue-color;
          font-weight: 400;
        }
        svg {
          margin-right: 4px;
        }
      }
    }
  }

  .task-right-action {
    border: 1px dashed #cdd9e9 !important;
    border-radius: 50%;
    font-size: 12px;
    width: 31px;
    height: 31px;
    margin-top: 10px;
    margin-right: 27px;
    &:hover {
      box-shadow: none !important;
    }
  }
</style>
